import { action } from 'satcheljs';
import { SelectedCalendarListViewType } from 'owa-scenario-settings';

export const updateSelectedCalendarView = action(
    'updateSelectedCalendarView',
    (updatedView: SelectedCalendarListViewType) => ({
        updatedView,
    })
);
